export const gstcInfo: any = {
  Hotels: {
    A1: `
      <div>
          <strong>Disclosure A1 Sustainability management system</strong>
      </div>
      <p style="text-indent:30px; text-align:justify">
          The organization has implemented a long-term sustainability management system that is suitable to its size and scope, addresses
          environmental, social, cultural, economic, quality, human rights, health, safety, risk and crisis management issues and drives continuous improvement.
      </p>`,
    A2: `
      <div>
          <strong>Disclosure A2 Legal compliance</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;">
          The organization is in compliance with all applicable local, national and international legislation and regulations including, among others, health, safety, profits and environmental aspects.
      </p>`,
    A3: `
      <div>
          <strong>Disclosure A3 Reporting and communication</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;">
          The organization communicates its sustainability policy, actions and performance to stakeholders, including customers, and seeks to engage their support.
      </p>`,
    A4: `
      <div>
          <strong>Disclosure A4 Staff engagement</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Staff are engaged with development and implementation of the sustainability management system and receive periodic guidance and training regarding their roles and responsibilities in its delivery.
      </p>`,
    A5: `
      <div>
          <strong>Disclosure A5 Customer experience</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;">      
          Customer satisfaction, including aspects of sustainability, is monitored and corrective action taken.
      </p>`,
    A6: `
      <div>
          <strong>Disclosure A6 Accurate promotion</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;">  
          Promotional materials and marketing communications are accurate and transparent with regard to the organization and its products and services, including sustainability claims.          
          They do not promise more than is being delivered.
      </p>`,
    A7: `
      <div>
          <strong>Disclosure A7 Buildings and infrastructure</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Buildings and infrastructure associated with the accommodation are compliant with zoning requirements and laws related to protected and sensitive areas and to heritage considerations. 
      </p>`,
    "A7.1": `
      <div>
          <strong>Disclosure A7.1 Compliance</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Comply with zoning requirements and laws related to protected and sensitive areas and to heritage considerations.
      </p>`,
    "A7.2": `
      <div>
          <strong>Disclosure A7.2 Impact and integrity</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Take account of the capacity and integrity of the natural and cultural surroundings.
      </p>`,
    "A7.3": `
      <div>
          <strong>Disclosure A7.3 Sustainable practices and materials</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Use locally appropriate and sustainable practices and materials.    
      </p>`,
    "A7.4": `
      <div>
          <strong>Disclosure A7.4 Access for all</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Provide access and information for persons with special needs, where appropriate.
      </p>`,
    A8: `
      <div>
          <strong>Disclosure A8 Land, water, and property rights</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Acquisition by the organization of land and water rights and of property is legal, complies with local communal and national 
          laws and regulations, including their free, priorand informed consent, and does not require involuntary resettlement.
      </p>`,
    A9: `
      <div>
          <strong>Disclosure A9 Information and interpretation</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization provides information about and interpretation of the natural surroundings, local culture, and cultural heritage,
          as well as an explanation of appropriate behaviour while visiting natural areas, living cultures, and cultural heritage sites.
      </p>`,
    A10: `
      <div>
          <strong>Disclosure A10 Destination engagement</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization is involved with sustainable tourism planning and management in the destination, where such opportunities exist.
      </p>`,
    B1: `
      <div>
          <strong>Disclosure B1 Community support</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization actively supports initiatives for local infrastructure and social community development. 
          Examples of initiatives include education, training, health and sanitation and projects which address the impacts of climate change.
      </p>`,
    B2: `
      <div>
          <strong>Disclosure B2 Local employment</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Local residents are given equal opportunities for employment and advancement, including in management positions.
      </p>`,
    B3: `
      <div>
          <strong>Disclosure B3 Local purchasing</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          When purchasing and offering goods and services, the organization gives priority to locally and fair trade suppliers whenever these are available and of sufficient quality.
      </p>`,
    B4: `
      <div>
          <strong>Disclosure B4 Local entrepreneurs</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization supports local entrepreneurs in the development and saleof sustainable products and services that are based on the area’s nature, history and culture.    
      </p>`,
    B5: `
      <div>
          <strong>Disclosure B5 Exploitation and harassment</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization has implemented a policyagainst commercial, sexual or any other form of exploitation or harassment, particularly of children, adolescents, women, minorities and other vulnerable groups.
      </p>`,
    B6: `
      <div>
          <strong>Disclosure B6 Equal opportunity</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization offers employment opportunities, including in management positions, without discrimination by gender, race, religion, disability or in other ways.
      </p>`,
    B7: `
      <div>
          <strong>Disclosure B7 Decent work</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Labour rights are respected, a safe and secure working environment is provided and employees are paid at least a living wage. 
          Employees are offered regular training, experience and opportunities for advancement.
      </p>`,
    B8: `
      <div>
          <strong>Disclosure B8 Community services</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The activities of the organization do not jeopardize the provision of basic services, such as food, water, energy, healthcare or sanitation, to neighbouring communities.
      </p>`,
    B9: `
      <div>
          <strong>Disclosure B9 Local livelihoods</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The activities of the organization do not adversely affect local access to livelihoods, including land and aquatic resource use, rights-of-way, transport and housing.
      </p>`,
    C1: `
      <div>   
          <strong>Disclosure C1 Cultural interactions</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization follows international and national good practice and locally agreed guidance for the management and promotion of visits to indigenous communities and 
          culturally or historically sensitive sites in order to minimize adverseimpacts and maximize local benefits and visitor fulfilment.
      </p>`,
    C2: `
      <div>   
          <strong>Disclosure C2 Protecting cultural heritage</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization contributes to the protection, preservation and enhancement of local properties, sites and traditions of historical, archaeological, cultural and spiritual
          significance and does not impede access to them by local residents.
      </p>`,
    C3: `
      <div>   
          <strong>Disclosure C3 Presenting culture and heritage</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization values and incorporates authentic elements of traditional and contemporary local culture in its operations, design, decoration, cuisine, or shops, 
          while respecting the intellectual property rights of local communities.
      </p>`,
    C4: `
      <div>   
          <strong>Disclosure C4 Artefacts</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Historical and archaeological artefacts are not sold, traded or displayed, except as permitted by local and international law.
      </p>`,
    "D1.1": `
      <div>   
          <strong>Disclosure D1.1 Environmentally preferable purchasing</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Purchasing policies favour environmentally sustainable suppliers and products, including capital goods, food, beverages, building materials and consumables.
      </p>`,
    "D1.2": `
      <div>   
          <strong>Disclosure D1.2 Efficient purchasing</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization carefully manages the purchasing of consumable and disposable goods, including food, in order to minimize waste.
      </p>`,
    "D1.3": `
      <div>   
          <strong>Disclosure D1.3 Energy conservation</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Energy consumption is measured by type and steps are taken to minimize overall consumption. The organization makes efforts to increase its use of renewable energy.
      </p>`,
    "D1.4": `
      <div>   
          <strong>Disclosure D1.4 Water conservation</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;">
          Water risk is assessed, water consumption is measured by type, and steps are taken to minimize overall consumption. Water 
          sourcing is sustainable and does not adversely affect environmental flows. In areas of high water risk, context-based water 
          stewardship goals are identified and pursued.
      </p>`,
    "D2.1": `
      <div>   
          <strong>Disclosure D2.1 Greenhouse gas emissions</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Significant greenhouse gas emissions from all sources controlled by the organization are identified, calculated where possible
          and procedures implemented to avoid or to minimize them. Offsetting of the organization's remaining emissions is encouraged.
      </p>`,
    "D2.2": `
      <div>   
          <strong>Disclosure D2.2 Transport</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization seeks to reduce transportation requirements and actively encourages the use of cleaner and more resource
          efficient alternatives by customers, employees, suppliers and in its own operations.
      </p>`,
    "D2.3": `
      <div>   
          <strong>Disclosure D2.3 Wastewater</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Wastewater, including grey water, is effectively treated and is only reused or released safely, withno adverse effects to the 
          local population or the environment.
      </p>`,
    "D2.4": `
      <div>   
          <strong>Disclosure D2.4 Solid waste</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Waste, including food waste, is measured, mechanisms are in place to reduce waste and, where reduction is not feasible, to reuse 
          or recycle it. Any residual waste disposal has no adverse effect on the local population or the environment.
      </p>`,
    "D2.5": `
      <div>   
          <strong>Disclosure D2.5 Harmful substances</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The use of harmful substances, including pesticides, paints, swimming pool disinfectants, and cleaning materials, is minimized, 
          and substituted when available by innocuous products or processes. All storage, use, handling, and disposal of chemicals are properly managed.
      </p>`,
    "D2.6": `
      <div>   
          <strong>Disclosure D2.6 Minimize pollution</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization implements practices to minimize pollution from noise, light, runoff, erosion, ozone- depleting substances, and 
          air, water and soil contaminants.
      </p>`,
    "D3.1": `
      <div>   
          <strong>Disclosure D3.1 Biodiversity conservation</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization supports and contributes to biodiversity conservation, including through appropriate management of its own property. 
          Particular attention is paid to natural protected areas and areas of high biodiversity value. Any disturbance of natural ecosystems is
          minimized, rehabilitated and there is a compensatory contribution to conservation management.
      </p>`,
    "D3.2": `
      <div>   
          <strong>Disclosure D3.2 Invasive species</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization takes measures to avoid the introduction of invasive species. Native species are used for landscaping and 
          restoration wherever feasible, particularly in natural landscapes.
      </p>`,
    "D3.3": `
      <div>   
          <strong>Disclosure D3.3 Visits to natural sites</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization follows appropriate guidelines for the management and promotion of visits to natural sites in order to minimize 
          adverse impacts and maximize visitor fulfilment.
      </p>`,
    "D3.4": `
      <div>   
          <strong>Disclosure D3.4 Wildlife interactions</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Interactions with free roaming wildlife, taking into account cumulative impacts, are non-invasive and responsibly managed to avoid 
          adverse effects on the animals concerned and on the viability and behaviour of populations in the wild.
      </p>`,
    "D3.5": `
      <div>   
          <strong>Disclosure D3.5 Animal welfare</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          No species of wild animal is acquired, bred or held captive, except by authorized and suitably equipped persons and for properly 
          regulated activities in compliance with local and international law. 
          Housing, care and handling of all wild and domestic animals meets the highest standards of animal welfare.
          No species of wild animal is acquired, bred or held captive, except by authorized and suitably equipped persons and for properly
          regulated activities in compliance with local and international law.
      </p>`,
    "D3.6": `
      <div>   
          <strong>Disclosure D3.6 Wildlife harvesting and trade</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Wildlife species are not harvested, consumed, displayed, sold, or traded, except as part of a regulated activity that ensures 
          that their utilization is sustainable, and in compliance with local and international laws.
      </p>`,
  },
  Tour: {
    A1: `
      <div>
          <strong>Disclosure A1 Sustainability management system</strong>
      </div>
      <p style="text-indent:30px; text-align:justify">
          The organization has implemented a long-term sustainability management system that is suitable to its size and scope, addresses
          environmental, social, cultural, economic, quality, human rights, health, safety, risk and crisis management issues and drives continuous improvement.
      </p>`,
    A2: `
      <div>
          <strong>Disclosure A2 Legal compliance</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;">
          The organization is in compliance with all applicable local, national and international legislation and regulations including, among others, health, safety, profits and environmental aspects.
      </p>`,
    A3: `
      <div>
          <strong>Disclosure A3 Reporting and communication</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;">
          The organization communicates its sustainability policy, actions and performance to stakeholders, including customers, and seeks to engage their support.
      </p>`,
    A4: `
      <div>
          <strong>Disclosure A4 Staff engagement</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Staff are engaged with development and implementation of the sustainability management system and receive periodic guidance and training regarding their roles and responsibilities in its delivery.
      </p>`,
    A5: `
      <div>
          <strong>Disclosure A5 Customer experience</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;">      
          Customer satisfaction, including aspects of sustainability, is monitored and corrective action taken.
      </p>`,
    A6: `
      <div>
          <strong>Disclosure A6 Accurate promotion</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;">  
          Promotional materials and marketing communications are accurate and transparent with regard to the organization and its products and services, including sustainability claims.          
          They do not promise more than is being delivered.
      </p>`,
    A7: `
      <div>
          <strong>Disclosure A7 Buildings and infrastructure</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Buildings and infrastructure associated with the accommodation are compliant with zoning requirements and laws related to protected and sensitive areas and to heritage considerations. 
      </p>`,
    "A7.1": `
      <div>
          <strong>Disclosure A7.1 Compliance</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Comply with zoning requirements and laws related to protected and sensitive areas and to heritage considerations.
      </p>`,
    "A7.2": `
      <div>
          <strong>Disclosure A7.2 Impact and integrity</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Take account of the capacity and integrity of the natural and cultural surroundings.
      </p>`,
    "A7.3": `
      <div>
          <strong>Disclosure A7.3 Sustainable practices and materials</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Use locally appropriate and sustainable practices and materials.    
      </p>`,
    "A7.4": `
      <div>
          <strong>Disclosure A7.4 Access for all</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Provide access and information for persons with special needs, where appropriate.
      </p>`,
    A8: `
      <div>
          <strong>Disclosure A8 Land, water, and property rights</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Acquisition by the organization of land and water rights and of property is legal, complies with local communal and national 
          laws and regulations, including their free, priorand informed consent, and does not require involuntary resettlement.
      </p>`,
    A9: `
      <div>
          <strong>Disclosure A9 Information and interpretation</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization provides information about and interpretation of the natural surroundings, local culture, and cultural heritage,
          as well as an explanation of appropriate behaviour while visiting natural areas, living cultures, and cultural heritage sites.
      </p>`,
    A10: `
      <div>
          <strong>Disclosure A10 Destination engagement</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization is involved with sustainable tourism planning and management in the destination, where such opportunities exist.
      </p>`,
    B1: `
      <div>
          <strong>Disclosure B1 Community support</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization actively supports initiatives for local infrastructure and social community development. 
          Examples of initiatives include education, training, health and sanitation and projects which address the impacts of climate change.
      </p>`,
    B2: `
      <div>
          <strong>Disclosure B2 Local employment</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Local residents are given equal opportunities for employment and advancement, including in management positions.
      </p>`,
    B3: `
      <div>
          <strong>Disclosure B3 Local purchasing</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          When purchasing and offering goods and services, the organization gives priority to locally and fair trade suppliers whenever these are available and of sufficient quality.
      </p>`,
    B4: `
      <div>
          <strong>Disclosure B4 Local entrepreneurs</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization supports local entrepreneurs in the development and saleof sustainable products and services that are based on the area’s nature, history and culture.    
      </p>`,
    B5: `
      <div>
          <strong>Disclosure B5 Exploitation and harassment</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization has implemented a policyagainst commercial, sexual or any other form of exploitation or harassment, particularly of children, adolescents, women, minorities and other vulnerable groups.
      </p>`,
    B6: `
      <div>
          <strong>Disclosure B6 Equal opportunity</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization offers employment opportunities, including in management positions, without discrimination by gender, race, religion, disability or in other ways.
      </p>`,
    B7: `
      <div>
          <strong>Disclosure B7 Decent work</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Labour rights are respected, a safe and secure working environment is provided and employees are paid at least a living wage. 
          Employees are offered regular training, experience and opportunities for advancement.
      </p>`,
    B8: `
      <div>
          <strong>Disclosure B8 Community services</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The activities of the organization do not jeopardize the provision of basic services, such as food, water, energy, healthcare or sanitation, to neighbouring communities.
      </p>`,
    B9: `
      <div>
          <strong>Disclosure B9 Local livelihoods</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The activities of the organization do not adversely affect local access to livelihoods, including land and aquatic resource use, rights-of-way, transport and housing.
      </p>`,
    C1: `
      <div>   
          <strong>Disclosure C1 Cultural interactions</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization follows international and national good practice and locally agreed guidance for the management and promotion of visits to indigenous communities and 
          culturally or historically sensitive sites in order to minimize adverseimpacts and maximize local benefits and visitor fulfilment.
      </p>`,
    C2: `
      <div>   
          <strong>Disclosure C2 Protecting cultural heritage</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization contributes to the protection, preservation and enhancement of local properties, sites and traditions of historical, archaeological, cultural and spiritual
          significance and does not impede access to them by local residents.
      </p>`,
    C3: `
      <div>   
          <strong>Disclosure C3 Presenting culture and heritage</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization values and incorporates authentic elements of traditional and contemporary local culture in its operations, design, decoration, cuisine, or shops, 
          while respecting the intellectual property rights of local communities.
      </p>`,
    C4: `
      <div>   
          <strong>Disclosure C4 Artefacts</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Historical and archaeological artefacts are not sold, traded or displayed, except as permitted by local and international law.
      </p>`,
    "D1.1": `
      <div>   
          <strong>Disclosure D1.1 Environmentally preferable purchasing</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Purchasing policies favour environmentally sustainable suppliers and products, including capital goods, food, beverages, building materials and consumables.
      </p>`,
    "D1.2": `
      <div>   
          <strong>Disclosure D1.2 Efficient purchasing</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization carefully manages the purchasing of consumable and disposable goods, including food, in order to minimize waste.
      </p>`,
    "D1.3": `
      <div>   
          <strong>Disclosure D1.3 Energy conservation</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Energy consumption is measured by type and steps are taken to minimize overall consumption. The organization makes efforts to increase its use of renewable energy.
      </p>`,
    "D1.4": `
      <div>   
          <strong>Disclosure D1.4 Water conservation</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;">
          Water risk is assessed, water consumption is measured by type, and steps are taken to minimize overall consumption. Water 
          sourcing is sustainable and does not adversely affect environmental flows. In areas of high water risk, context-based water 
          stewardship goals are identified and pursued.
      </p>`,
    "D2.1": `
      <div>   
          <strong>Disclosure D2.1 Greenhouse gas emissions</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Significant greenhouse gas emissions from all sources controlled by the organization are identified, calculated where possible
          and procedures implemented to avoid or to minimize them. Offsetting of the organization's remaining emissions is encouraged.
      </p>`,
    "D2.2": `
      <div>   
          <strong>Disclosure D2.2 Transport</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization seeks to reduce transportation requirements and actively encourages the use of cleaner and more resource
          efficient alternatives by customers, employees, suppliers and in its own operations.
      </p>`,
    "D2.3": `
      <div>   
          <strong>Disclosure D2.3 Wastewater</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Wastewater, including grey water, is effectively treated and is only reused or released safely, withno adverse effects to the 
          local population or the environment.
      </p>`,
    "D2.4": `
      <div>   
          <strong>Disclosure D2.4 Solid waste</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Waste, including food waste, is measured, mechanisms are in place to reduce waste and, where reduction is not feasible, to reuse 
          or recycle it. Any residual waste disposal has no adverse effect on the local population or the environment.
      </p>`,
    "D2.5": `
      <div>   
          <strong>Disclosure D2.5 Harmful substances</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The use of harmful substances, including pesticides, paints, swimming pool disinfectants, and cleaning materials, is minimized, 
          and substituted when available by innocuous products or processes. All storage, use, handling, and disposal of chemicals are properly managed.
      </p>`,
    "D2.6": `
      <div>   
          <strong>Disclosure D2.6 Minimize pollution</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization implements practices to minimize pollution from noise, light, runoff, erosion, ozone- depleting substances, and 
          air, water and soil contaminants.
      </p>`,
    "D3.1": `
      <div>   
          <strong>Disclosure D3.1 Biodiversity conservation</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization supports and contributes to biodiversity conservation, including through appropriate management of its own property. 
          Particular attention is paid to natural protected areas and areas of high biodiversity value. Any disturbance of natural ecosystems is
          minimized, rehabilitated and there is a compensatory contribution to conservation management.
      </p>`,
    "D3.2": `
      <div>   
          <strong>Disclosure D3.2 Invasive species</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization takes measures to avoid the introduction of invasive species. Native species are used for landscaping and 
          restoration wherever feasible, particularly in natural landscapes.
      </p>`,
    "D3.3": `
      <div>   
          <strong>Disclosure D3.3 Visits to natural sites</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The organization follows appropriate guidelines for the management and promotion of visits to natural sites in order to minimize 
          adverse impacts and maximize visitor fulfilment.
      </p>`,
    "D3.4": `
      <div>   
          <strong>Disclosure D3.4 Wildlife interactions</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Interactions with free roaming wildlife, taking into account cumulative impacts, are non-invasive and responsibly managed to avoid 
          adverse effects on the animals concerned and on the viability and behaviour of populations in the wild.
      </p>`,
    "D3.5": `
      <div>   
          <strong>Disclosure D3.5 Animal welfare</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          No species of wild animal is acquired, bred or held captive, except by authorized and suitably equipped persons and for properly 
          regulated activities in compliance with local and international law. 
          Housing, care and handling of all wild and domestic animals meets the highest standards of animal welfare.
          No species of wild animal is acquired, bred or held captive, except by authorized and suitably equipped persons and for properly
          regulated activities in compliance with local and international law.
      </p>`,
    "D3.6": `
      <div>   
          <strong>Disclosure D3.6 Wildlife harvesting and trade</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Wildlife species are not harvested, consumed, displayed, sold, or traded, except as part of a regulated activity that ensures 
          that their utilization is sustainable, and in compliance with local and international laws.
      </p>`,
  },
  Destinations: {
    A1: `
      <div>
          <strong>Disclosure A1 Destination management responsibility</strong>
      </div>
      <p style="text-indent:30px; text-align:justify">
          The destination has an effective organization, department, group, or committee responsible for a coordinated approach to sustainable tourism, with involvement by the private sector, public sector and civil society. This group has defined responsibilities, oversight, and implementation capability for the management of socio- economic, cultural and environmental issues. The group is adequately funded, works with a range of bodies in delivering destination management, has accessto sufficient staffing (including personnel with experience in sustainability) and follows principles of sustainability and transparency in its operations and transactions.
      </p>`,
    A2: `
      <div>
          <strong>Disclosure A2 Destination management strategy and action plan</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;">
          The destination has established and is implementing a multi-year destination management strategy and action plan that is publicly available, is suited to its scale, was developed with stakeholder engagement and isbased on sustainability principles. The strategy includes an identification and assessment of tourism assets and considers socio-economic, cultural and environmental issues and risks.
          The strategy relates to and influences wider sustainable development policy and action inthe destination.
      </p>`,
    A3: `
      <div>
          <strong>Disclosure A3 Monitoring and reporting</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;">
          The destination is implementing a system to monitor and respond to socio-economic, cultural and environmental issues and impacts arising from tourism. Actions and outcomes are regularly monitored, evaluated and publicly reported. The monitoring system is periodically reviewed.
      </p>`,
    A4: `
      <div>
          <strong>Disclosure A4 Enterprise engagement and sustainability standards</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination regularly informs tourism- related enterprises about sustainability issuesand encourages and supports them in makingtheir operations more sustainable. The destination promotes the adoption of sustainability standards, promoting the application of GSTC-I Recognized standards and GSTC-I Accredited certification schemes for tourism enterprises, where available. Thedestination publicizes a list of sustainability certified enterprises.
      </p>`,
    A5: `
      <div>
          <strong>Disclosure A5 Resident engagement and feedback</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;">      
          The destination enables and promotes public participation in sustainable destination planning and management. Local communities’ aspirations, concerns and satisfaction with tourism sustainability and destination management are regularly monitored and publicly reported, and action istaken in response to them. The destination has a system to enhance local understanding of sustainable tourism opportunities and challenges and to build the capacity of communities to respond.
      </p>`,
    A6: `
      <div>
          <strong>Disclosure A6 Visitor engagement and feedback</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;">  
          The destination has a system to monitor and publicly report visitor satisfaction with the quality and sustainability of the destination experience and, if necessary, to take action inresponse. Visitors are informed about sustainability issues in the destination and thepart that they can play in addressing them.
      </p>`,
    A7: `
      <div>
          <strong>Disclosure A7 Promotion and information</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          Promotion and visitor information material about the destination is accurate with regard to its products, services, and sustainability claims.
          Marketing messages and other communications reflect the destination’s values and approach to sustainability and treatlocal communities and natural and cultural assets with respect.
      </p>`,
    A8: `
      <div>
          <strong>Disclosure A8 Managing visitor volumes and activities</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has a system for visitor management which is regularly reviewed. Action is taken to monitor and manage the volume and activities of visitors, and to reduce or increase them as necessary at certain times and in certain locations, working to balance theneeds of the local economy, community, cultural heritage and environment.
      </p>`,
    A9: `
      <div>
          <strong>Disclosure A9 Planning regulations and development control</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has planning guidelines, regulations and/or policies which control the location and nature of development, require environmental, economic, and socio-cultural impact assessment and integrate sustainable land use, design, construction, and demolition. Regulations also apply to operations, including property rental and concessions for tourism purposes. The guidelines, regulations and policies were created with public participationand are widely communicated and enforced.
      </p>`,
    A10: `
      <div>
          <strong>Disclosure A10 Climate change adaptation</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination identifies risks and opportunities associated with climate change.Climate change adaptation strategies are pursued for the siting, design, development and management of tourism facilities.
          Information on predicted climate change, associated risks and future conditions is provided for residents, businesses and visitors.
      </p>`,
    A11: `
      <div>
          <strong>Disclosure A11 Risk and crisis management</strong>
      </div>
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has a risk reduction, crisis management and emergency response plan that is appropriate to the destination. Key elements are communicated to residents, visitors, and enterprises. Procedures and resources are established for implementing theplan and it is regularly updated.
      </p>`,
    B1: `
      <div>
          <strong>Disclosure B1  Measuring the economic contribution of tourism</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The direct and indirect economic contribution of tourism to the destination’s economy is monitored and publicly reported. Appropriate measures may include levels of visitor volume,visitor expenditure, employment and investment and evidence on the distribution of economic benefits.
      </p>`,
    B2: `
      <div>
          <strong>Disclosure B2 Decent work and career opportunities</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination encourages and supports career opportunities and training in tourism. The
          destination’s tourism enterprises committo providing equality of opportunity for local employment, training and advancement, a safe and secure working environment, and a living wage for all.
      </p>`,
    B3: `
      <div>
          <strong>Disclosure B3 Supporting local entrepreneurs and fair trade</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination encourages the retention of tourism spending in the local economy through supporting local enterprises, supply chains and sustainable investment. It promotes the development and purchase of local sustainable products based on fair trade principles and that reflect the area’s nature and culture. These may include food andbeverages, crafts, performance arts, agricultural products, etc. 
      </p>`,
    B4: `
      <div>
          <strong>Disclosure B4 Support for community</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has a system to enable and encourage enterprises, visitors, and the publicto contribute to community and sustainability initiatives in a responsible manner.
      </p>`,
    B5: `
      <div>
          <strong>Disclosure B5 Preventing exploitation and discrimination</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination upholds international standards on human rights. It has laws, practices and an established code of conduct to prevent and report on human trafficking, modern slavery and commercial, sexual, or any other form of exploitation, discriminationand harassment of or against anyone, particularly children, adolescents, women, LGBT and other minorities. The laws and established practices are publicly communicated and enforced.
      </p>`,
    B6: `
      <div>
          <strong>Disclosure B6  Property and user rights</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Laws and regulations regarding property rights and acquisitions are documented and enforced. They comply with communal and indigenous rights, ensure public consultationand do not authorize resettlement without free prior and informed consent and fair and just compensation. Laws and regulations alsoprotect user and access rights to key resources.
      </p>`,
    B7: `
      <div>
          <strong>Disclosure B7 Safety and security</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;">           
          The destination has a system to monitor, prevent, publicly report, and respond to crime, safety, and health hazards that addresses the needs of both visitors and residents.      
      </p>`,
    B8: `
      <div>
          <strong>Disclosure B8  Access for all</strong>  
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Where practical, sites, facilities and services, including those of natural and cultural importance, are accessible to all, including persons with disabilities and others who havespecific access requirements or other special needs. Where sites and facilities are not immediately accessible, access is afforded through the design and implementation of solutions that take into account both the integrity of the site and such reasonable accommodations for persons with access requirements as can be achieved.
          Informationis made available on the accessibility of sites, facilities and services.
      </p>`,
    C1: `
      <div>   
          <strong>Disclosure C1 Protection of cultural assets</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has a policy and system to evaluate, rehabilitate, and conserve cultural assets, including built heritage and cultural landscapes.
      </p>`,
    C2: `
      <div>   
          <strong>Disclosure C2 Cultural artefacts</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has laws governing the propersale, trade, display, or gifting of historical and archaeological artefacts. The laws are enforced and publicly communicated, including to tourism enterprises and visitors.
      </p>`,
    C3: `
      <div>   
          <strong>Disclosure C3  Intangible heritage</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;">
          The destination supports the celebration and protection of intangible cultural heritage, including local traditions, arts, music, language, gastronomy and other aspects of local identity and distinctiveness. The presentation, replication and interpretation ofliving culture and traditions is sensitive and respectful, seeks to involve and benefit local communities, and provides visitors with an authentic and genuine experience.
      </p>`,
    C4: `
      <div>   
          <strong>Disclosure C4 Traditional Access</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination monitors, protects, and when necessary rehabilitates or restores local community access to natural and cultural sites.     
      </p>`,
    C5: `
      <div>   
          <strong>Disclosure C5 Intellectual Property</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has a system to contribute to the protection and preservation of intellectual property rights of communities and individuals.      
      </p>`,
    C6: `
      <div>   
          <strong>Disclosure C6 Visitor management at cultural sites</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has a system for the management of visitors within and around cultural sites, which takes account of their characteristics, capacity and sensitivity and seeks to optimize visitor flow and minimize adverse impacts. Guidelines for visitor behaviour at sensitive sites and cultural events are made available to visitors, tour operators and guides before and at the timeof the visit.
      </p>`,
    C7: `
      <div>   
          <strong>Disclosure C7 Site interpretation</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          Accurate interpretative material is provided which informs visitors of the significance of the cultural and natural aspects of the sites they visit. The information is culturally appropriate, developed with host communitycollaboration, and clearly communicated in languages pertinent to visitors and residents.
      </p>`,
    D1: `
      <div>   
          <strong>Disclosure D1 Protection of sensitive environments</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
        The destination has a system to monitor, measure and respond to the impacts of tourism on the natural environment, conserveecosystems, habitats and species, and preventthe introduction and spread of invasive species.
      </p>`,
    D2: `
      <div>   
          <strong>Disclosure D2 Visitor management at natural sites</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has a system for the management of visitors within and around natural sites, which takes account of their characteristics, capacity and sensitivity and seeks to optimize visitor flow and minimize adverse impacts. Guidelines for visitor behaviour at sensitive sites are made availableto visitors, tour operators and guides before and at the time of the visit.
      </p>`,
    D3: `
      <div>   
          <strong>Disclosure D3 Wildlife interaction</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has a system to ensure compliance with local, national, and international laws and standards for wildlife interactions. Interactions with free roaming wildlife, taking into account cumulative impacts, are non-invasive and responsibly
          managed to avoid adverse impacts on the animals concerned and on the viability and behaviour of populations in the wild.
      </p>`,
    D4: `
      <div>   
          <strong>Disclosure D4 Species exploitation and animal welfare</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has a system to ensure compliance with local, national, and international laws and standards that seek to ensure animal welfare and conservation of species (animals, plants and all living organisms). This includes the harvesting or capture, trade, display, and sale of wildlife species and their products. No species of wildanimal is acquired, bred or held captive, except by authorized and suitably equipped persons and for properly regulated activities. Housing, care and handling of all wild and domestic animals meets the highest standardsof animal welfare.     
      </p>`,
    D5: `
      <div>   
          <strong>Disclosure D5 Energy conservation</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has targets to reduce energy consumption, improve efficiency in its use, aswell as increase the use of renewable energy.The destination has a system to encourage enterprises to measure, monitor, reduce, and publicly report their contribution to these targets.      
      </p>`,
    D6: `
      <div>   
          <strong>Disclosure D6 Water stewardship</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination encourages enterprises to measure, monitor, publicly report and manage water usage. Water risk in the destination is assessed and documented. In cases of high water risk, water stewardship goals are identified and actively pursued with enterprises, to ensure that tourism use does not conflict with the needs of local communities and ecosystems.
      </p>`,
    D7: `
      <div>   
          <strong>Disclosure D7 Water quality</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination monitors water quality for drinking, recreational and ecological purposes using quality standards. The monitoring results are publicly available, and the destination has a system to respond in a timely manner to water quality issues.      
      </p>`,
    D8: `
      <div>   
          <strong>Disclosure D8 Wastewater</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has clear and enforced guidelines in place for the siting, maintenanceand testing of discharge from septic tanks andwastewater treatment systems. The destination ensures that wastes are properly treated and reused or released safely withoutadverse impacts on the local population and the environment.
      </p>`,
    D9: `
      <div>   
          <strong>Disclosure D4 Solid Waste</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination measures and reports on its generation of waste and sets targets for its reduction. It ensures solid waste is properly treated and diverted from landfill, with provision of a multiple-stream collection andrecycling system which effectively separates waste by type. The destination encourages enterprises to avoid, reduce, reuse, and recycle solid waste, including food waste.
          Action is taken to eliminate or reduce single-use items, especially plastics. Any residual solid waste that is not reused or recycled is disposed of safely and sustainably.
      </p>`,
    D10: `
      <div>   
          <strong>Disclosure D10 GHG emissions and climate change mitigation</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has targets to reduce greenhouse gas emissions, and implements and reports on mitigation policies and actions.Enterprises are encouraged to measure, monitor, reduce or minimise, publicly report and mitigate greenhouse gas emissions from all aspects of their operation (including from suppliers and service providers). Offsetting ofany remaining emissions is encouraged.
      </p>`,
    D11: `
      <div>   
          <strong>Disclosure D11 Low-impact transportation</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has targets to reduce transport emissions from travel to and within the destination. An increase in the use of sustainable, low-emissions vehicles and publictransport and active travel (e.g., walking and cycling) is sought in order to reduce the contribution of tourism to air pollution, congestion and climate change.
      </p>`,
    D12: `
      <div>   
          <strong>Disclosure D12 Light and noise pollution</strong>
      </div>  
      <p style="text-indent:30px ; text-align:justify;"> 
          The destination has guidelines and regulationsto minimize light and noise pollution. The destination encourages enterprises to follow these guidelines and regulations.
      </p>`,
  },
};
